import { NavLink } from 'react-router-dom'

import { useSelectedTalent } from '@/hooks/useSelectedTalent'
import { gettext as _ } from '@/lib/i18n'
import styles from './Layout.module.css'

interface NavEntry {
  label: string
  to: string
  icon: string
}

export function Sidebar() {
  const { selectedTalentId } = useSelectedTalent()

  const navEntries: NavEntry[] = [
    { label: '대시보드', to: '/', icon: '◉' },
    { label: '소스 취합', to: `/talents/${selectedTalentId}/sources`, icon: '◎' },
    { label: '이력서 스튜디오', to: `/talents/${selectedTalentId}/resumes`, icon: '▤' },
    { label: _('Portfolio'), to: `/talents/${selectedTalentId}/portfolios`, icon: '🗂' },
    { label: 'Notion 연동', to: `/talents/${selectedTalentId}/notion`, icon: '◈' },
    { label: '채용 매칭', to: `/talents/${selectedTalentId}/job-matches`, icon: '◇' },
    { label: '맞춤 자소서', to: `/talents/${selectedTalentId}/cover-letters`, icon: '✎' },
    { label: '면접 준비', to: `/talents/${selectedTalentId}/interview-scripts`, icon: '🎓' },
  ]

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sidebarLogo}>
        <span className={styles.logoAccent}>✦</span>
        <span className="logoMark">Career Studio</span>
      </div>

      <nav className={styles.sidebarNav}>
        <div className={styles.sidebarSection}>메인</div>
        {navEntries.map((entry) => (
          <NavLink
            key={entry.to}
            to={entry.to}
            end={entry.to === '/'}
            className={({ isActive }) =>
              isActive
                ? `${styles.navItem} ${styles.navItemActive}`
                : styles.navItem
            }
          >
            <span className={styles.navIcon}>{entry.icon}</span>
            <span>{entry.label}</span>
          </NavLink>
        ))}

        <div className={styles.sidebarSection}>설정</div>
        <NavLink
          to="/settings"
          className={({ isActive }) =>
            isActive ? `${styles.navItem} ${styles.navItemActive}` : styles.navItem
          }
        >
          <span className={styles.navIcon}>⚙</span>
          <span>설정</span>
        </NavLink>
      </nav>

      <div className={styles.sidebarFooter}>
        <div className={styles.footerUser}>
          <span className={styles.footerAvatar}>이</span>
          <span>이헌제</span>
        </div>
      </div>
    </aside>
  )
}
